/*
 * @Description:
 * @Date: 2024-03-20 16:06:39
 */
export const ROAD_WEB_VALUE = 1;
export const ROAD_APP_VALUE = 2;
export const ROAD_MINI_VALUE = 3;
export const ROAD_TYPE_MAP = {
  [ROAD_WEB_VALUE]: '官网',
  [ROAD_APP_VALUE]: '移动端'
  // [ROAD_MINI_VALUE]: '小程序'
};
export const ROAD_TYPE = Object.keys(ROAD_TYPE_MAP).map(key => ({
  label: ROAD_TYPE_MAP[key],
  value: +key
}));

export const PRESCRIPTION_NO_VALUE = 0;
export const PRESCRIPTION_YES_VALUE = 1;
export const PRESCRIPTION_TYPE_MAP = {
  [PRESCRIPTION_NO_VALUE]: '否',
  [PRESCRIPTION_YES_VALUE]: '是'
};
export const PRESCRIPTION_TYPE = Object.keys(PRESCRIPTION_TYPE_MAP).map(
  key => ({
    label: PRESCRIPTION_TYPE_MAP[key],
    value: +key
  })
);

export const STATUS_NO_RELEASED_VALUE = 1;
export const STATUS_NO_CONFIRM_VALUE = 2;
export const STATUS_AUDIT_VALUE = 2;
export const STATUS_RELEASED_VALUE = 3;
export const STATUS_REJECT_VALUE = 4;
export const STATUS_SUSPEND_VALUE = 5;
export const STATUS_TYPE_MAP = {
  [STATUS_NO_RELEASED_VALUE]: '待发布',
  [STATUS_NO_CONFIRM_VALUE]: '待确认',
  // [STATUS_AUDIT_VALUE]: '待审核',
  [STATUS_RELEASED_VALUE]: '已发布',
  [STATUS_REJECT_VALUE]: '已驳回',
  [STATUS_SUSPEND_VALUE]: '已停用'
};
export const STATUS_TYPE = Object.keys(STATUS_TYPE_MAP).map(key => ({
  label: STATUS_TYPE_MAP[key],
  value: +key
}));

export const MODIFY_STATUS_NO_VALUE = 1;
export const MODIFY_STATUS_TODO_VALUE = 2;
export const MODIFY_MODIFY_PASS_VALUE = 3;
export const MODIFY_STATUS_RELEASED_VALUE = 4;
export const MODIFY_STATUS_TYPE_MAP = {
  [MODIFY_STATUS_NO_VALUE]: '未修改',
  [MODIFY_STATUS_TODO_VALUE]: '待审核',
  [MODIFY_MODIFY_PASS_VALUE]: '审核通过',
  [MODIFY_STATUS_RELEASED_VALUE]: '已驳回'
};
export const MODIFY_STATUS_TYPE = Object.keys(MODIFY_STATUS_TYPE_MAP).map(
  key => ({
    label: MODIFY_STATUS_TYPE_MAP[key],
    value: +key
  })
);

export const PRODUCT_DRUG = 1;
export const PRODUCT_DEVICE = 2;
export const PRODUCT_TYPE_MAP = {
  [PRODUCT_DRUG]: '药品',
  [PRODUCT_DEVICE]: '器械'
};
export const PRODUCT_TYPE = Object.keys(PRODUCT_TYPE_MAP).map(key => ({
  label: PRODUCT_TYPE_MAP[key],
  value: +key
}));

export const PRODUCT_SOURCE_PROJECT = 1;
export const PRODUCT_SOURCE_LIBRARY = 2;
export const PRODUCT_SOURCE_CUSTOM = 3;
export const PRODUCT_SOURCE_MAP = {
  [PRODUCT_SOURCE_PROJECT]: '项目',
  [PRODUCT_SOURCE_LIBRARY]: '药品库',
  [PRODUCT_SOURCE_CUSTOM]: '自定义'
};
export const PRODUCT_SOURCE = Object.keys(PRODUCT_SOURCE_MAP).map(key => ({
  label: PRODUCT_SOURCE_MAP[key],
  value: +key
}));

export const TAG_SOURCE_SYSTEM = 1;
export const TAG_SOURCE_CUSTOM = 2;
export const TAG_SOURCE_MAP = {
  [TAG_SOURCE_SYSTEM]: '系统',
  [TAG_SOURCE_CUSTOM]: '自定义'
};
export const TAG_SOURCE = Object.keys(TAG_SOURCE_MAP).map(key => ({
  label: TAG_SOURCE_MAP[key],
  value: +key
}));

export const PUBLISH_SOURCE_COMPANY = 1;
export const PUBLISH_SOURCE_SYSTEM = 2;
export const PUBLISH_SOURCE_MAP = {
  [PUBLISH_SOURCE_COMPANY]: '企业',
  [PUBLISH_SOURCE_SYSTEM]: '平台'
};
export const PUBLISH_SOURCE = Object.keys(PUBLISH_SOURCE_MAP).map(key => ({
  label: PUBLISH_SOURCE_MAP[key],
  value: +key
}));

export const OPTION_TYPE_RADIO = 1;
export const OPTION_TYPE_CHECKBOX = 2;
export const OPTION_TYPE_MAP = {
  [OPTION_TYPE_RADIO]: '单选',
  [OPTION_TYPE_CHECKBOX]: '多选'
};
export const OPTION_TYPE = Object.keys(OPTION_TYPE_MAP).map(key => ({
  label: OPTION_TYPE_MAP[key],
  value: +key
}));
